function dcg_ExecuteModule ( module , param , callback , options ) {
    callback = callback || null ;
    options = options || {} ;

    var url = SETUP_INDEX + '?module=' + module ;

    var param_new = {} ;
    param_new.index = {} ;
    param_new.index[ module ] = param ;

    url += '&' + $.param( param_new ) ;
    url += '&index[' + module + '][skipMainTemplate]=TRUE' ;
    url += '&token=' + CSRF_TOKEN ;
    url += '&ajax=TRUE' ;

    return $.ajax( url , options ).done ( callback ) ;
}

jQuery.fn.getModuleContents = function ( module , param , callback ) {
    var pTarget = this ;
    callback = callback || null ;

    $(pTarget).addClass('is-updating');
    if ($(pTarget).hasClass('supress-loading-anim') === false) {
        $(pTarget).html('<div class="loading"></div>');
    }

    dcg_ExecuteModule ( module , param , function ( contents ) {
        $( pTarget ).html ( contents ) ;
        $( pTarget ).addClass('is-loaded');
        $( pTarget ).removeClass('is-updating');
        $( pTarget ).trigger ( 'areaReady' ) ;


        if ( callback != null ) {
            callback ( $( pTarget ) ) ;
        }
    } ) ;
}

jQuery.fn.getSelectOptions = function ( settings ) {
    var pSelect = this ;

    settings = jQuery.extend ( {
        target: null ,
        target_hide: null ,

        module: null ,
        param: {} ,
        param_val: null ,
        type: 'html' ,

        callback: function ( data ) { }
    } , settings ) ;

    return pSelect.change ( function () {
        var pValue = $( this ).val() ;

        settings.param[ settings.param_val ] = pValue ;

        dcg_ExecuteModule ( settings.module , settings.param ,
            function ( data ) {
                $( 'option' , $( settings.target ) ).not ( "[value='0']" ).remove () ;

                $( 'option' , data ).each ( function () {
                    $( settings.target ).append ( $( this ) ) ;
                } ) ;

                if ( settings.target_hide !== null ) {
                    if ( $( 'option' , $( settings.target ) ).length > 1 ) {
                        $( settings.target_hide ).show () ;
                    } else {
                        $( settings.target_hide ).hide () ;
                    }
                }

                settings.callback ( data , this ) ;
            }
        ) ;
    } ) ;
};

jQuery.fn.executeModule = function ( callback ) {
    var elems = this ;

    callback = callback || function ( a ) {} ;

    $( elems ).each ( function () {
        var module = $( this ).attr ( 'data-module' ) ;
        var params = {} ;
        var target = this ;

        $.each ( this.attributes , function () {
            if ( this.specified ) {
                if ( this.name.substr ( 0 , 5 ) == 'data-' && this.name != 'data-module' ) {
                    var use_value = this.value ;

                    try {
                        var encode = use_value ;
                            encode = window.atob ( encode );

                        var json = JSON.parse ( encode ) ;

                        use_value = encode ;
                    } catch ( e ) {

                    }

                    try {
                       var json = JSON.parse(use_value);

                        params[ this.name.substr ( 5 ) ] = json ;
                    } catch ( e ) {
                        params[ this.name.substr ( 5 ) ] = use_value ;
                    }
                }
            }
        } ) ;

        $( target ).getModuleContents ( module , params , callback ) ;
    })
}

$(document).on('areaReady', function(event) {
    $('.js-exec-module', event.target).executeModule() ;
}) ;
